import { createSlice } from "@reduxjs/toolkit";
import {
  HeaderData,
  HeaderInitialStatus,
} from "../../../../types/webCms/header";

import { getAllHeaderDataAsync, updateHeaderDataAsync } from "./headerApi";

const initialState: HeaderInitialStatus<HeaderData> = {
  loading: false,
  manageLoading: false,
  headerDataList: null,
  countHeaderData: 0,
};

const headerUpdateSlice = createSlice({
  name: "admin-header",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllHeaderDataAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllHeaderDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.headerDataList = action.payload?.data || null;
        state.countHeaderData = action.payload?.length || 0;
      })
      .addCase(getAllHeaderDataAsync.rejected, (state) => {
        state.loading = false;
        state.headerDataList = null;
        state.countHeaderData = 0;
      });

    // update
    builder
      .addCase(updateHeaderDataAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateHeaderDataAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateHeaderDataAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default headerUpdateSlice;
